import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

import GameContainer from './GameContainer.js';

import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';
import { getSoundPropsById, isNotEmpty } from '../../lib/ep.js';
import HiddenCanvas from '../games/HiddenCanvas_new.js';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';

const Instructions = (props) => {
	return null;
};

const Legend = ({ stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const display_legend = stage?.display_legend ?? true;

	if(display_legend === false) return null;

	const areas = (stage?.hidden_areas ?? []).map((area) => ({ ...area }));

	return (
		<aside class="gui_legend gui_main_text_color_on_bg">
			{areas.map((area, a) => {
				const classes = ['tip_label', 'cutTextOnOverflow'];
				if((props?.found ?? []).includes(area.id)) classes.push('is_done');

				const area_name = (isNotEmpty(area, 'name')) ? area.name : `${i18n("Area")}_${a}`;

				return (
					<span key={a} class={classes.join(" ")}>{area_name}</span>
				)
			})}
		</aside>
	)
};

const HiddenClient = ({ stage, ...props }) => {
	const canvas_images = () => {
		const images = [];
		if (isNotEmpty(stage.Stage, 'hidden_image')) {
			images.push({
				id:'hidden_image',
				name:stage.Stage.hidden_image,
				url:stage.Stage.full_hidden_image,
				fit:'contain'
			})
		}
		
		return images;
	};

	const sound_fx = {
		error:new Howl({ ...getSoundPropsById('error_backflip') }),
		found:new Howl({ ...getSoundPropsById('success') }),
		success:new Howl({ ...getSoundPropsById('applause') }),
		fail:new Howl({ ...getSoundPropsById('fail') }),
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[stage.Stage.hidden_image],
	});

	const [ found_areas, setFoundAreas ] = useState([]);

	const onFound = (a) => {
		const _fa = [ ...found_areas ];
		_fa.push(a);
		setFoundAreas(_fa);
	};

	const onResetFounds = () => {
		setFoundAreas([]);
	};

	const final_stage = clientFinalPage(stage, props.actual_state);

	return (
		<GameContainer
			{...props}
			stage={final_stage}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			legend={(stage?.Stage?.display_legend ?? true) ? <Legend
				stage={stage?.Stage}
				intl={props.intl}
				found={found_areas}
			/> : null}
			game_type="hidden_objects"
			auto_start_timer={false}
			display_audio_controls={true}
			instructions_has_border={false}
			instructions_classes='gui_flex_align_center'
			sound_fx={sound_fx}
		>
			{(stage.Stage?.hidden_image ?? false) ? (
				<HiddenCanvas
					indexed_images={state.images}
					is_edit_mode={props.is_edit_mode}
					saveAreas={props?.saveAreas}
					onFound={onFound}
					onResetFounds={onResetFounds}
				/>
			) : (
				<MisconfiguredGameWarning
					message="Upload an image to create the game"
					img_recommendations={{
						w:800,
						h:800,
					}}
				/>
			)}
			
		</GameContainer>
	)
};

export default injectIntl(HiddenClient);